import Dialog from '@/components/Dialog'
import { useProducts } from '@/lib/hooks/useProducts'
import { SHOW_ADD_SERVICE, useApp } from '@/lib/provider/AppProvider'
import ProductCard from '@/pages/dashboard/partials/ProductCard'

const AddService = () => {
  const [appState, appDispatch] = useApp()
  const products = useProducts()

  const handleClose = () => {
    appDispatch({ type: SHOW_ADD_SERVICE, payload: false })
  }

  if (!appState.isAddServiceShown) return null

  return (
    <Dialog
      title="Add a Service"
      message="We're designing a suite of services to meet all of your connectivity needs."
      onDismiss={handleClose}
      onConfirm={handleClose}
      hasButtons={false}
      closable
      scrollableBody
      maxWidth="md:max-w-3xl"
    >
      <div className="grid gap-2.5 sm:grid-cols-2">
        {products.map((p) => (
          <ProductCard
            key={p.id}
            product={p}
            cy={p.id}
            onSelect={handleClose}
            actions="header-link"
            clampLines={4}
          />
        ))}
      </div>
    </Dialog>
  )
}

export default AddService
